import React, { Component } from 'react'
import { getToken } from 'core/libs/lib-token-helpers'
import { styles } from './styles.scss'

class SelectedCurrency extends Component {
  render() {
    const { currency } = this.props

    return (
      <div className={styles}>
        <div className="selected-currency">
          <img width="35" src={getToken(`${currency}Token`)} />
        </div>
      </div>
    )
  }
}

export default SelectedCurrency
